<div class="item-container pt-0">
    <div class="edit-icons" (click)="onCancel()"> 
        <i class="material-icons">close</i>
    </div>
    <div class="content"  *ngIf="(dialogData.api_type=='exam'||dialogData.api_type=='informational')">
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/object_icons/next_exam.png" class="img-fluid" alt="">
        </div>
        <div class="px-3 ">
            <h5 class="text-center item-txt mt-3">{{"Course Completed"}}</h5>
            <div class="item-small mt-2 text-center" *ngIf="dialogData.api_type=='exam' && (dialogData.e_t=='o')">{{"Great! Press Exam to take exam."}}</div>
            <div class="item-small mt-2 text-center" *ngIf="dialogData.api_type=='exam' && (dialogData.e_t!='o')">{{"Great! Press Exam to go to exam list"}}</div>
            <div class="item-small mt-2 text-center" *ngIf="dialogData.api_type=='informational'">{{"Great! You have completed the informational course"}}</div>
        </div>       
    </div>
    <div class="content"  *ngIf="(dialogData.api_type=='module')">
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/object_icons/next_module.png" class="img-fluid" alt="">
        </div>
        <div class="px-3 px-lg-5 mx-xl-5">
            <h5 class="text-center item-txt mt-3">{{"Module Completed"}}</h5>
            
        </div>
        <div class="item-small mt-2 text-center px-xl-5">{{"Great! You still have some modules pending to complete."}}</div>
    </div>
    <div class="btn-container d-flex mt-4 mt-xl-5 justify-content-center">
        <button color="" class="auth-form-btn outline-btn new-outline d-flex align-items-center justify-content-center"
            (click)="onCancel()">Cancel</button>
            <button mat-raised-button color="primary" class="auth-form-btn  ms-3"  type="submit" *ngIf="dialogData.api_type!='exam'&&(dialogData.api_type!='module')"> Next</button>    
            <button mat-raised-button color="primary" class="auth-form-btn  ms-3 no-sh-btn"  type="submit" *ngIf="dialogData.api_type=='exam'" (click)="onExam()"> Exam</button>  
    </div>
</div>